import React from 'react';
import AdminResourceManagerPage from '../../components/admin/AdminResourceManagerPage';

export default function AdminLibraryResourcesPage() {
  return <AdminResourceManagerPage moduleKey="libraryResources" title="Links e documentos da Biblioteca" description="Atualize acessos digitais, regulamentos e links úteis exibidos na página da Biblioteca." createLabel="Novo link ou documento" emptyMessage="Nenhum recurso cadastrado." supportsTag />;
}
